export enum Rarity {
	Common,
	Uncommon,
	Rare,
	Epic,
	Legendary,
}

export enum ItemCode {
	None,
	Money,
	Gem,
	LevelCrystal,
	Token2,
	Token3,
	Token4,
	Token5,

	RankBRock,		// beta
	RankARock,		// alpha
	RankSRock,		// sigma
	RankSSRock,		// theta
	RankSSSRock,	// zeta

	Score1kRock,	// genius
	Score5kRock,	// pro
	Score10kRock,	// expert
	Score100kRock,	// master
	Score1mRock,	// grandmaster

	Kill1Rock,		// rage
	Kill2Rock,		// blood
	Kill3Rock,	// death
	Kill4Rock,	// carnage
	Kill5Rock,	// extinction


	SpinelOre,
	GarnetOre,
	RubyOre,

	CopperOre,
	CitrineOre,
	GoldOre,

	PeridotOre,
	TurquoiseOre,
	EmeraldOre,

	LapisLazuliOre,
	AquamarineOre,
	SapphireOre,

	QuartzOre,
	AmethystOre,
	DiamondOre,

	IronOre,
	SilverOre,
	MythrilOre,

	SharkOrb,
	DolphinOrb,
	WhaleOrb,

	BlueSharkStone,
	BlueSharkGem,
	GreatWhiteSharkStone,
	GreatWhiteSharkGem,
	MegalodonStone,
	MegalodonGem,
	HammerheadStone,
	HammerheadGem,
	HammeredHeadStone,
	HammeredHeadGem,
	WhammyHeadStone,
	WhammyHeadGem,
	KillerWhaleStone,
	KillerWhaleGem,
	SerialKillerWhaleStone,
	SerialKillerWhaleGem,
	PsychoKillerWhaleStone,
	PsychoKillerWhaleGem,


	BumpOnHead,
	Bungalow,
	Bandaid,
	BandaidX,
	Glasses,
	SpiralGlasses,
	Monocle,
	GentlemanMustache,
	RedNose,
	Scar1,
	ScarX,
	Warpaint1,
	Warpaint2,
	Warpaint4,

	BpBumpOnHead,
	BpBungalow,
	BpBandaid,
	BpBandaidX,
	BpGlasses,
	BpSpiralGlasses,
	BpMonocle,
	BpGentlemanMustache,
	BpRedNose,
	BpScar1,
	BpScarX,
	BpWarpaint1,
	BpWarpaint2,
	BpWarpaint4,

	BikerSunglasses,
	Saber,
	SharkSaberBlue,
	SharkSaberRed,
	SharkSaberYellow,
	SharkSaberPurple,
	BpBikerSunglasses,
	BpSaber,
	BpSharkSaberBlue,
	BpSharkSaberRed,
	BpSharkSaberYellow,
	BpSharkSaberPurple,

	BottlenoseDolphinStone,
	BottlenoseDolphinGem,
	CommonDolphinStone,
	CommonDolphinGem,
	SpinnerDolphinStone,
	SpinnerDolphinGem,

	BeachBall,
	Hoop,
	AmericanFootball,
	BpBeachBall,
	BpHoop,
	BpAmericanFootball,

	Sword,
	DolphinSwordBlack,
	DolphinSwordPurple,
	DolphinSwordTeal,
	DolphinSwordGreen,
	BpSword,
	BpDolphinSwordBlack,
	BpDolphinSwordPurple,
	BpDolphinSwordTeal,
	BpDolphinSwordGreen,

	PufferfishOrb,
	NarwhalOrb,

	PufferfishStone,
	PufferfishGem,
	PorcupinefishStone,
	PorcupinefishGem,
	OnifuguStone,
	OnifuguGem,
	NarwhalStone,
	NarwhalGem,
	BelugaStone,
	BelugaGem,
	ArchBelugaStone,
	ArchBelugaGem,

	CarpOrb,
	TurtleOrb,

	GoldfishStone,
	GoldfishGem,
	GoldenfishStone,
	GoldenfishGem,
	DiamondfishStone,
	DiamondfishGem,
	GreenSeaTurtleStone,
	GreenSeaTurtleGem,
	LeatherbackStone,
	LeatherbackGem,
	AlligatorSnappingTurtleStone,
	AlligatorSnappingTurtleGem,

	BlueCap,
	Shield,
	BpBlueCap,
	BpShield,

	CephalopodOrb,
	MythicalOrb,

	HumpbackWhaleStone,
	HumpbackWhaleGem,
	BlueWhaleStone,
	BlueWhaleGem,
	JomamaStone,
	JomamaGem,
	DumboOctopusStone,
	DumboOctopusGem,
	TakoStone,
	TakoGem,
	KrakenStone,
	KrakenGem,

	RayOrb,
	EelOrb,
	KnifefishOrb,

	MantaRayStone,
	MantaRayGem,
	MantraRayStone,
	MantraRayGem,
	BlueRayStone,
	BlueRayGem,
	MorayEelStone,
	MorayEelGem,
	GulperEelStone,
	GulperEelGem,
	ElectricEelStone,
	ElectricEelGem,

	SantaHat,
	CandyStick,
	ReindeerHeadband,
	StarLantern,

	BpSantaHat,
	BpCandyStick,
	BpReindeerHeadband,
	BpStarLantern,

	// LongGlasses,
	// RibbonPink,
	// Blush,
	// WhiteFlower,
}


export type ItemType = 'currency' | 'material' | 'deco' | 'blueprint' | 'skin' | 'pet';

export interface ItemInfo {
	code: ItemCode,
	type: ItemType,
	tradable: boolean,
	name: string,
	desc: string,
	rarity: Rarity,
	decoLimit?: number,
}

export const itemInfos: ItemInfo[] = [];


let code: ItemCode;

code = ItemCode.None;
itemInfos[code] = {
	code,
	type: 'currency',
	name: 'None',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.Money;
itemInfos[code] = {
	code,
	type: 'currency',
	name: 'Gold',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};

code = ItemCode.Gem;
itemInfos[code] = {
	code,
	type: 'currency',
	name: 'Black Pearl',
	tradable: false,
	desc: '',
	rarity: Rarity.Legendary,
};

// Rewards

code = ItemCode.LevelCrystal;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Level Crystal',
	tradable: false,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.RankBRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Rank B Plate',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.RankARock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Rank A Plate',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.RankSRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Rank S Plate',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.RankSSRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Rank SS Plate',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.RankSSSRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Rank SSS Plate',
	tradable: false,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.Score1kRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Adequate Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.Score5kRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Pro Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.Score10kRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Expert Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.Score100kRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Master Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.Score1mRock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Grandmaster Crystal',
	tradable: false,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.Kill1Rock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Rage Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.Kill2Rock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blood Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.Kill3Rock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Death Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.Kill4Rock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Carnage Crystal',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.Kill5Rock;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Extinction Crystal',
	tradable: false,
	desc: '',
	rarity: Rarity.Legendary,
};


// Ore

code = ItemCode.SpinelOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Spinel Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.GarnetOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Garnet Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.RubyOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Ruby Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};


code = ItemCode.CopperOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Copper Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.CitrineOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Citrine Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.GoldOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Gold Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.PeridotOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Peridot Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.TurquoiseOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Turquoise Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.EmeraldOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Emerald Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.LapisLazuliOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Lapis Lazuli Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.AquamarineOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Aquamarine Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.SapphireOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Sapphire Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.QuartzOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Quartz Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.AmethystOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Amethyst Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.DiamondOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Diamond Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.IronOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Iron Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.SilverOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Silver Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.MythrilOre;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Mythril Ore',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};

// Fish Orbs

code = ItemCode.SharkOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Shark Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.DolphinOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Dolphin Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.WhaleOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Whale Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.PufferfishOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Puffer Fish Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.NarwhalOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Narwhal Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.CarpOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Carp Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.TurtleOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Turtle Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.CephalopodOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Cephalopod Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.MythicalOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Mythical Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.RayOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Ray Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.EelOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Eel Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.KnifefishOrb;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Knifefish Orb',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};



// Fish Stones

code = ItemCode.BlueSharkStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blue Shark Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.BlueSharkGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blue Shark Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.GreatWhiteSharkStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Great White Shark Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.GreatWhiteSharkGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Great White Shark Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.MegalodonStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Megalodon Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.MegalodonGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Megalodon Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};


code = ItemCode.HammerheadStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Hammerhead Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.HammerheadGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Hammerhead Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.HammeredHeadStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'HammeredHead Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.HammeredHeadGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'HammeredHead Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};

code = ItemCode.WhammyHeadStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Whammyhead Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.WhammyHeadGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Whammyhead Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};


code = ItemCode.KillerWhaleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Killer Whale Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.KillerWhaleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Killer Whale Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.SerialKillerWhaleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Serial Killer Whale Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.SerialKillerWhaleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Serial Killer Whale Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.PsychoKillerWhaleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Psycho Killer Whale Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.PsychoKillerWhaleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Psycho Killer Whale Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.BottlenoseDolphinStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Bottlenose Dolphin Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.BottlenoseDolphinGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Bottlenose Dolphin Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.CommonDolphinStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Common Dolphin Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.CommonDolphinGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Common Dolphin Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.SpinnerDolphinStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Spinner Dolphin Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.SpinnerDolphinGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Spinner Dolphin Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};


code = ItemCode.PufferfishStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Puffer Fish Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.PufferfishGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Puffer Fish Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.PorcupinefishStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Porcupine Fish Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.PorcupinefishGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Porcupine Fish Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.OnifuguStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Onifugu Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.OnifuguGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Onifugu Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.NarwhalStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Narwhal Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.NarwhalGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Narwhal Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.BelugaStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Beluga Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.BelugaGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Beluga Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.ArchBelugaStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'ArchBeluga Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.ArchBelugaGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'ArchBeluga Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.GoldfishStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Goldfish Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.GoldfishGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Goldfish Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.GoldenfishStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Goldenfish Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.GoldenfishGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Goldenfish Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.DiamondfishStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Diamond Fish Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.DiamondfishGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Diamond Fish Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.GreenSeaTurtleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Green Sea Turtle Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.GreenSeaTurtleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Green Sea Turtle Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.LeatherbackStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Leatherback Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.LeatherbackGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Leatherback Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.AlligatorSnappingTurtleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Alligator Snapping Turtle Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.AlligatorSnappingTurtleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Alligator Snapping Turtle Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.HumpbackWhaleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Humpback Whale Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.HumpbackWhaleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Humpback Whale Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.BlueWhaleStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blue Whale Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.BlueWhaleGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blue Whale Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.JomamaStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Jomama Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.JomamaGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Jomama Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.DumboOctopusStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Dumbo Octopus Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.DumboOctopusGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Dumbo Octopus Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.TakoStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Tako Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.TakoGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Tako Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.KrakenStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Kraken Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.KrakenGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Kraken Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.MantaRayStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Manta Ray Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.MantaRayGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Manta Ray Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.MantraRayStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Mantra Ray Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.MantraRayGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Mantra Ray Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.BlueRayStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blue Ray Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.BlueRayGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Blue Ray Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.MorayEelStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Moray Eel Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.MorayEelGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Moray Eel Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.GulperEelStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Gulper Eel Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.GulperEelGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Gulper Eel Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};
code = ItemCode.ElectricEelStone;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Electric Eel Stone',
	rarity: Rarity.Common,
	tradable: true,
	desc: '',
};
code = ItemCode.ElectricEelGem;
itemInfos[code] = {
	code,
	type: 'material',
	name: 'Electric Eel Gem',
	rarity: Rarity.Legendary,
	tradable: true,
	desc: '',
};

// Decorations
code = ItemCode.BumpOnHead;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Bump On Head',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
	decoLimit: 1,
};
code = ItemCode.Bungalow;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Bungalow',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
	decoLimit: 1,
};
code = ItemCode.Bandaid;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Bandaid',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.BandaidX;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Bandaid X',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};

code = ItemCode.Glasses;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Glasses',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.SpiralGlasses;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Spiral Glasses',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.Monocle;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Monocle',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.GentlemanMustache;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Gentleman Mustache',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.RedNose;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Red Nose',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.Scar1;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Scar',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.ScarX;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Scar X',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.Warpaint1;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Warpaint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.Warpaint2;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Warpaint 2',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.Warpaint4;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Warpaint 4',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};

code = ItemCode.BikerSunglasses;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Biker Sunglasses',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.Saber;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Saber',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.SharkSaberRed;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Red Shark Saber',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.SharkSaberBlue;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Blue Shark Saber',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.SharkSaberYellow;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Yellow Shark Saber',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.SharkSaberPurple;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Purple Shark Saber',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};

code = ItemCode.BeachBall;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Beach Ball',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.Hoop;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Hula Hoop',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.AmericanFootball;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'American Football',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};

code = ItemCode.Sword;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Sword',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.DolphinSwordBlack;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Black Dolphin Sword',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.DolphinSwordPurple;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Purple Dolphin Sword',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.DolphinSwordTeal;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Teal Dolphin Sword',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.DolphinSwordGreen;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Green Dolphin Sword',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BlueCap;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Blue Cap',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.Shield;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Shield',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.SantaHat;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Santa Hat',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.CandyStick;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Candy Stick',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.ReindeerHeadband;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Reindeer Headband',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.StarLantern;
itemInfos[code] = {
	code,
	type: 'deco',
	name: 'Star Lantern',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};







// Blueprint
code = ItemCode.BpBumpOnHead;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Bump On Head Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.BpBungalow;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Bungalow Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.BpBandaid;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Bandaid Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.BpBandaidX;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Bandaid X Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};

code = ItemCode.BpGlasses;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Glasses Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.BpSpiralGlasses;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Spiral Glasses Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.BpMonocle;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Monocle Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpGentlemanMustache;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Gentleman Mustache Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.BpRedNose;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Red Nose Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpScar1;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Scar Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.BpScarX;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Scar X Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpWarpaint1;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Warpaint Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpWarpaint2;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Warpaint 2 Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpWarpaint4;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Warpaint 4 Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};

code = ItemCode.BpBikerSunglasses;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Biker Sunglasses Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpSaber;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Saber Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpSharkSaberRed;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Red Shark Saber Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpSharkSaberBlue;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Blue Shark Saber Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpSharkSaberYellow;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Yellow Shark Saber Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpSharkSaberPurple;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Purple Shark Saber Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpBeachBall;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Beach Ball Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.BpHoop;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Hula Hoop Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.BpAmericanFootball;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'American Football Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Rare,
};
code = ItemCode.BpSword;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Sword Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpDolphinSwordBlack;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Black Dolphin Sword Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpDolphinSwordPurple;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Purple Dolphin Sword Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpDolphinSwordTeal;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Teal Dolphin Sword Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpDolphinSwordGreen;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Green Dolphin Sword Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
code = ItemCode.BpBlueCap;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Blue Cap Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.BpShield;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Shield Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpSantaHat;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Santa Hat Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Common,
};
code = ItemCode.BpCandyStick;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Candy Stick Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Uncommon,
};
code = ItemCode.BpReindeerHeadband;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Reindeer Headband Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Epic,
};
code = ItemCode.BpStarLantern;
itemInfos[code] = {
	code,
	type: 'blueprint',
	name: 'Star Lantern Blueprint',
	tradable: true,
	desc: '',
	rarity: Rarity.Legendary,
};
